import FormField from '@sportnet/ui/lib/FormField/redux-form';
import * as React from 'react';
import { Field } from 'redux-form';
import { IFormSegmentElement } from '../../../library/Form';
import getValidationFunctions from '../../../utilities/getValidationFunctions';
import isNumber from '../../../utilities/isNumber';
import parseToDecimal from '../../../utilities/parseToDecimal';

interface OwnProps {
  data: IFormSegmentElement;
  name: string;
  disabled: boolean;
}

const COMPONENT_VALIDATIONS: Array<
  (value: string | number) => string | null
> = [isNumber];

class DecimalInputFormElement extends React.PureComponent<OwnProps> {
  render() {
    const { data, name, disabled } = this.props;
    const isRequired = (data.validations || []).find(
      validation => validation.type === 'required',
    );

    return (
      <Field
        {...(!!isRequired && {
          required: true,
        })}
        type="number"
        readOnly={disabled}
        validate={[
          ...COMPONENT_VALIDATIONS,
          ...getValidationFunctions(data.validations || []),
        ]}
        name={name}
        parse={parseToDecimal}
        format={(i: number) => (Number.isNaN(i) ? '' : i)}
        component={FormField}
        label={data.label}
      />
    );
  }
}

export default DecimalInputFormElement;
